import { EUserRole } from "../types/enums";

/** Tokens do claim `role` (ex.: `ADMIN`, `OWNER,ADMIN`). Igualdade exata por token — evita falso positivo por substring. */
function normalizedRoleTokens(raw: string | undefined | null): string[] {
  const trimmed = String(raw ?? "").trim();
  if (!trimmed) return [];
  const upper = trimmed.toUpperCase();
  if (/[,;|]/.test(upper)) {
    return upper.split(/[,;|]+/).map((t) => t.trim()).filter(Boolean);
  }
  return [upper];
}

export function authHasRole(raw: string | undefined | null, role: EUserRole): boolean {
  const wanted = String(role).toUpperCase();
  return normalizedRoleTokens(raw).includes(wanted);
}

export const isAuthAdmin = (raw: string | undefined | null): boolean => authHasRole(raw, EUserRole.ADMIN);

export const isAuthOwner = (raw: string | undefined | null): boolean => authHasRole(raw, EUserRole.OWNER);

export const isAuthSupport = (raw: string | undefined | null): boolean => authHasRole(raw, EUserRole.SUPPORT);

/** Superfície operacional (visão global, operação de lives/câmeras/logos). NÃO inclui telas exclusivas de ADMIN. */
export const hasOperationalAccess = (raw: string | undefined | null): boolean =>
  isAuthAdmin(raw) || isAuthSupport(raw);
